import { createGlobalStyle } from "styled-components";

export const Styles = createGlobalStyle`
  @font-face {
    font-family: "Motiva Sans";
    src: url("/fonts/Motiva-Sans-Light.ttf") format("truetype");
    font-style: normal;
    font-weight: 400;
    font-display: swap;
  }

  @font-face {
    font-family: "Motiva Sans";
    src: url("/fonts/Motiva-Sans-Bold.ttf") format("truetype");
    font-style: normal;
    font-weight: 600 800;
    font-display: swap;
  }

  :root {
    --primary-blue: #12306b;
    --primary-blue-deep: #081c43;
    --primary-blue-soft: #eaf0ff;
    --secondary-teal: #0e9f8d;
    --secondary-teal-soft: #e2f8f3;
    --accent-coral: #f06f4f;
    --success-green: #1f9d6a;
    --background: #f8fafc;
    --surface: #ffffff;
    --surface-alt: #f0f4f9;
    --surface-raised: rgba(255, 255, 255, 0.82);
    --text-primary: #10213f;
    --text-secondary: #53627a;
    --text-muted: #748197;
    --border-color: #dce4ef;
    --border-strong: #c8d3e2;
    --shadow: rgba(16, 33, 63, 0.08);
    --shadow-hover: rgba(16, 33, 63, 0.16);
    --input-bg: #ffffff;
    --card-bg: #ffffff;
    --white: #ffffff;
    --radius-sm: 12px;
    --radius-md: 20px;
    --radius-lg: 30px;
    --page-width: 1200px;
  }

  [data-theme="dark"] {
    --primary-blue: #8fb1ff;
    --primary-blue-deep: #dbe6ff;
    --primary-blue-soft: #172a50;
    --secondary-teal: #44cbb8;
    --secondary-teal-soft: #123c3a;
    --background: #08101f;
    --surface: #101b2e;
    --surface-alt: #142238;
    --surface-raised: rgba(16, 27, 46, 0.86);
    --text-primary: #f1f5fb;
    --text-secondary: #b6c2d4;
    --text-muted: #8e9bb0;
    --border-color: #293952;
    --border-strong: #3b4e69;
    --shadow: rgba(0, 0, 0, 0.28);
    --shadow-hover: rgba(0, 0, 0, 0.42);
    --input-bg: #101b2e;
    --card-bg: #101b2e;
  }

  *, *::before, *::after { box-sizing: border-box; }

  html {
    scroll-behavior: smooth;
    background: var(--background);
  }

  body {
    margin: 0;
    min-width: 320px;
    overflow-x: hidden;
    background: var(--background);
    color: var(--text-primary);
    font-family: "Motiva Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
    -webkit-font-smoothing: antialiased;
    transition: background-color 0.25s ease, color 0.25s ease;
  }

  body, button, input, textarea, select, a {
    font-family: "Motiva Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  }

  ::selection {
    color: #ffffff;
    background: var(--secondary-teal);
  }

  h1, h2, h3, h4, h5, h6, p { margin-top: 0; }

  h1, h2, h3, h4, h5, h6 {
    color: var(--text-primary);
    font-weight: 700;
    letter-spacing: -0.035em;
  }

  h1 { font-size: clamp(2.65rem, 5vw, 4.25rem); line-height: 1.04; }
  h2 { font-size: clamp(2.2rem, 4vw, 3.5rem); line-height: 1.08; }
  h3 { font-size: clamp(1.35rem, 2vw, 1.8rem); line-height: 1.2; }

  p {
    color: var(--text-secondary);
    font-size: 1.0625rem;
    line-height: 1.75;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  button, a { -webkit-tap-highlight-color: transparent; }

  :focus-visible {
    outline: 3px solid rgba(14, 159, 141, 0.32);
    outline-offset: 3px;
  }

  input, textarea {
    width: 100%;
    padding: 0.95rem 1.1rem;
    border: 1px solid var(--border-color);
    border-radius: var(--radius-sm);
    outline: none;
    background: var(--input-bg);
    color: var(--text-primary);
    font-size: 1rem;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;

    &:focus {
      border-color: var(--secondary-teal);
      box-shadow: 0 0 0 4px rgba(14, 159, 141, 0.12);
    }
  }

  img, svg { max-width: 100%; }

  .ant-drawer-content,
  .ant-drawer-header {
    background: var(--surface) !important;
  }

  .ant-drawer-body {
    display: flex;
    flex-direction: column;
    padding: 1.5rem !important;
    background: var(--surface);
  }

  .ant-drawer-content-wrapper { width: min(340px, 90vw) !important; }

  .mobile-drawer-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    svg { max-width: 138px; }
    > button {
      display: grid;
      width: 38px;
      height: 38px;
      place-items: center;
      border: 1px solid var(--border-color);
      border-radius: 10px;
      background: var(--surface-alt);
      color: var(--text-primary);
      cursor: pointer;
    }
  }
`;
